import { API_BASE } from './apiBase';

// The duel inbox (people who played your runs, rematches waiting for you).
// Kept apart from duel.ts, which pulls in the question bank, so the homepage
// can show the badge without downloading every question.

export function duelPlayerId(): string {
  let id = localStorage.getItem('bf_player_id');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('bf_player_id', id);
  }
  return id;
}

export interface InboxItem {
  id: number;
  kind: 'result' | 'rematch';
  fromName: string | null;
  category: string;
  theirScore: number;
  yourScore: number | null;
  code: string;
  createdAt: number;
  seen: boolean;
  taunt: string | null; // their quick-chat message, if any
  avatar: string | null; // their chosen avatar
  answered: boolean; // you've already rematched / played it
}

export async function fetchInbox(): Promise<{ items: InboxItem[]; unseen: number }> {
  const player = localStorage.getItem('bf_player_id');
  if (!player) return { items: [], unseen: 0 };
  const res = await fetch(`${API_BASE}/api/duel/inbox?player=${encodeURIComponent(player)}`);
  if (!res.ok) throw new Error(`inbox ${res.status}`);
  return res.json();
}

export async function markInboxSeen(): Promise<void> {
  await fetch(`${API_BASE}/api/duel/inbox/seen`, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ playerId: duelPlayerId() }),
  });
}

export function timeAgo(ts: number, now = Date.now()): string {
  const mins = Math.max(0, Math.round((now - ts) / 60_000));
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}
